export const getViableCalendarNotifiers = (eventType) => {
  const { isCollectiveRoundRobin, user_pools: userPools = [], memberships = [] } = eventType

  const collectivePoolUuid = userPools.find((pool) => pool.pooling_type === 'collective')?.uuid
  return isCollectiveRoundRobin
    ? memberships.filter((m) => collectivePoolUuid === m.user_pool_uuid)
    : memberships
}

export const hasActiveNotifiableCalendar = (eventType) => (
  getViableCalendarNotifiers(eventType).some((m) => m.has_active_notifiable_calendar)
)

// Calendar invitations cannot be sent without an active notifiable calendar. When
// disconnected, confirmation UI and persisted notification_type both fall back to
// email so save payloads match what the landing view displays.
export const getEffectiveNotificationType = (eventType, notificationType) => (
  notificationType === 'calendar' && !hasActiveNotifiableCalendar(eventType)
    ? 'email'
    : notificationType
)
